import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import api from '../../services/api';
import api2 from '../../services/api2';
import {
  Container,
  TextField,
  Autocomplete,
} from '@mui/material';
import * as Yup from 'yup';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import { useStyles } from '../../components/Styles';
import GroupButton from '../../components/Buttons/ButtonGroup';
import TextFieldCustom from '../../components/Inputs/TextField/TextField';

function Movement() {
  const location = useLocation();
  const [openProgress, setOpenProgress] = useState(false);

  const [bills, setBills] = useState([]);
  const [selectedBill, setSelectedBill] = useState(null);

  const [accountsCenter, setAccountsCenter] = useState([]);
  const [selectedAccountCenter, setSelectedAccountCenter] = useState(null);

  const [space, setSpace] = useState(0);
  const s = '\xa0\xa0';

  const disable = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();
  const history = useHistory();
  const dispatch = useDispatch();
  let { id } = useParams();
  const classes = useStyles();

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);

    setSelectedBill(data.bill);
    setSelectedAccountCenter(data.accountCenter);

    if (location.state !== undefined) {
      id = null;
      formik.setFieldValue('id', null);
    }
  }

  const formik = useFormik({
    initialValues: {
      bill: null,
      accountCenter: null,
      value: '',
      description: '',
    },
    validationSchema: Yup.object({
      description: Yup.string().required('Campo Obrigatório'),
      value: Yup.number()
        .required('Campo Obrigatório')
        .min(0, 'Precisa ser acima de 0')
        .max(
          999999999,
          'Valor máximo ultrapassado. Diminua o tamanho da amostra',
        )
        .typeError(
          'O valor deve ser um número. Caso seja um número decimal utilize " . " ao invés de " , "',
        ),
    }),
    onSubmit: (values) => {
      dispatch(setDisable(true));
      dispatch(setLoading(true));
      request(values);
    },
  });

  function pegaMaior(params) {
    let space = 0;
    for (const i in params) {
      if (space < params[i].cod.length) {
        space = params[i].cod.length;
      }
    }
    setSpace(space);
  }

  useEffect(() => {
    async function load() {
      // carrega caso tenha id, do contrario carrega vazio para cadastrar um novo
      setOpenProgress(true);

      const bill_ = await api.get('/pay-bills/');
      setBills(bill_.data);

      const accountCenter_ = await api.get('/accounts-center/');
      setAccountsCenter(accountCenter_.data);

      pegaMaior(accountCenter_.data);

      setOpenProgress(false);
    }
    load();
  }, []);

  async function request(data) {
    // envia os dados para api2 salvar no banco
    try {
      id
        ? await api2.put(`/movements/${id}`, { ...data })
        : await api2.post('/movements', { ...data });
      success();
      history.push('/movements');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  return (
    <Container>
      {openProgress ? <Progress /> : null}
      <form onSubmit={formik.handleSubmit}>
        <form className={classes.root}>
          <h2 className="title">Movimentação</h2>

          <Autocomplete
            noOptionsText="Sem opções"
            id="bill"
            name="bill"
            options={bills}
            value={selectedBill}
            getOptionLabel={(options) => options.description}
            onChange={(p, v) => {
              setSelectedBill(v);
              formik.setFieldValue('bill', v);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Conta" variant="outlined" />
            )}
          />

          <Autocomplete
            noOptionsText="Sem opções"
            id="accountCenter"
            name="accountCenter"
            options={accountsCenter}
            value={selectedAccountCenter}
            getOptionLabel={(options) => `${options.cod
            }\xa0${
              s.repeat(space - options.cod.length)
            }${options.description}`}
            onChange={(p, v) => {
              setSelectedAccountCenter(v);
              formik.setFieldValue('accountCenter', v);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Centro de Conta"
                variant="outlined"
              />
            )}
          />

          <TextFieldCustom
            id="description"
            label="Descrição"
            formik={formik}
            value={formik.values.description}
            onChange={(e) => formik.setFieldValue('description', e.target.value)}
          />
          <NumberFormat
            InputLabelProps={{
              style: { pointerEvents: 'auto' },
              shrink: true,
            }}
            fullWidth
            id="value"
            label="Valor da Movimentação"
            variant="outlined"
            name="value"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            prefix="R$"
            value={String(formik.values.value)}
            onValueChange={(values) => {
              formik.setValues({
                ...formik.values,
                value: String(values.floatValue),
              });
            }}
            onBlur={formik.handleBlur}
            customInput={TextField}
          />
        </form>

        <GroupButton
          deleteRoute="/movements/"
          routeDelete="/movements"
          returnRoute="/movements"
          id={id}
          disable={disable}
          message="A exclusão pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
        />
      </form>
    </Container>
  );
}

export default Movement;
